/**
 * @format
 * @flow
 */
import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DateJp from 'UltraDate.js';
import * as RT from '../../../constants/Routing';
import Modal from '../../../components/Common/Modal';
import * as Actions from '../../../actions/Template';
import Template from '../../../components/Template/AfterLoginTemplate';
import { Link } from "react-router-dom";
import TemplateModal from "../../../components/Common/TemplateModal";

DateJp.setDefaultLocale('ja');

class Component extends React.Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
        this.state = {
            isTemplateModal: false,
            selectedId: ""
        };
        this.currentUser = JSON.parse(localStorage.getItem('current_user'));
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
        this.callGetTemplateDataApi()
    }

    // eslint-disable-next-line react/no-deprecated,no-undef
    componentWillReceiveProps(nextProps: Props, nextContext: *) {
        if (nextProps.Template.TemplateDelete) {
            this.setState({ isTemplateModal: false });
            this.props.resetDeleteTemplateData();
            this.callGetTemplateDataApi();
        }
    }

    callGetTemplateDataApi = () => {
        const body = {
            enterpriseId: this.currentUser.enterpriseId,
        };
        const token = this.currentUser.accessToken;
        this.props.getTemplateData(body, token);
    }

    _renderTemplateItems = () => {
        const items = this.props.Template.TemplateItems;
        if (items !== null && items !== undefined && items.length > 0) {
            return items.map((item, index) => {
                return (
                    <tr>
                        <td>
                            <label
                                className={item.templateStatus === 2 ? "template_status1" : "template_status2"}
                            >
                                {item.templateStatus === 2 ? "公開" : " 下書き"}
                            </label>
                        </td>
                        <td>{item.templateName}</td>
                        <td>{item.createDate}</td>
                        <td>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,react/button-has-type,react/no-unused-state */}
                            <Link to={RT.TEMPLATE_EDIT_PATH.replace(':id', item.templateId)}
                                className="btn  btn-md  btn-pink"
                            >
                                編集
                            </Link>
                        </td>
                        <td>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,react/button-has-type */}
                            <button
                                onClick={() => this.setState({ selectedId: item.templateId, isTemplateModal: true })}
                                className="btn  btn-md  btn-gray"
                            >
                                削除
                            </button>
                        </td>
                    </tr>
                );
            });
        }
        else {
            return (
                <tr>
                    <td colSpan="6">FAQはありません。</td>
                </tr>
            );
        }
    };

    _onCancelClick = () => {
        this.setState({ isTemplateModal: false })
    };

    deleteItem = id => {
        const body = {
            enterpriseId: this.currentUser.enterpriseId,
            templateId: id,
            deleteFlag: true
        };
        const token = this.currentUser.accessToken;
        this.props.deleteTemplate(body, token);
    }

    render = () => {
        return (
            <Template>
                <TemplateModal
                    isOpen={this.state.isTemplateModal}
                    okClickHandler={() => this._onCancelClick()}
                    titleText="このテンプレートを削除しますか？"
                    onPublishClick={() => {
                        this.deleteItem(this.state.selectedId);
                    }}
                />
                <div className="">
                    <div className="Template_row">
                        <div className="template_row_1">
                            <h2 className="title">注意事項テンプレート作成</h2>
                        </div>
                        <div className="template_row_2">
                            <Link to={RT.TEMPLATE_CREATE_PATH}
                                className="btn btn-primary btn-md green-button"
                            >
                                新規作成
                            </Link>
                        </div>
                    </div>
                    <h3 className="sub-title">承認済みのタスクルーに送る注意事項やメッセージなどのテンプレートを作成・編集します</h3>
                    <div className="invoice-table table-responsive">
                        <table className="table payment-table">
                            <thead>
                                <tr>
                                    <th>ステータス</th>
                                    <th>タイトル</th>
                                    <th>更新日</th>
                                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                                    <th />
                                    {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                                    <th />
                                </tr>
                            </thead>
                            <tbody>{this._renderTemplateItems()}</tbody>
                        </table>
                    </div>
                    {(() => {
                        if (this.state.loaded) {
                            return this._renderPaging();
                        }
                    })()}
                </div>
            </Template>
        );
    };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);

// this.setState({ feeRate: `${feeRate}%` })
